import { z } from 'zod';

import { PaymentId } from '../BrandedIds';
import { BaseLoanEvent } from './BaseLoanEvent';

export const UsioMarkAsProcessedEvent = BaseLoanEvent.extend({
  type: z.literal('usioMarkAsProcessed'),
  paymentId: PaymentId,
});
export type UsioMarkAsProcessedEvent = z.infer<typeof UsioMarkAsProcessedEvent>;
